import callApi from '@/utils/callApi';

let fetchPromise = false;

export const fetchBalances = async() => {
  try {
    const res = await callApi('GET', '/v1/client/my-balance');
  
    if (res.status === 401) {
      return null;
    }
    
    const tokenBalances = await res.json();
    return tokenBalances
  } catch (e) {
    return null;
  }
}

export const getMyTokenBalance = async () => {  
  if (fetchPromise) {
    return fetchPromise;
  }

  fetchPromise = fetchBalances();

  const tokenBalances = await fetchPromise;
  fetchPromise = null;

  return tokenBalances;
}

export default getMyTokenBalance;